/* Contact page copy. The email, location and status lines come from RESUME
 * in the cabinet's data.ts. */

export const CONTACT_PAGE = {
    meta: "Get in touch with Mara Ellison, product designer in Lisbon. Send a message about a project, a freelance role or a talk, and hear back within two working days.",
    title: "Say hello",
    intro: "Working on a game, an app or an idea that's still half a sketch? Tell me what you're making and where you're stuck.",
    reply: "I answer every message within two working days, Monday to Friday, Lisbon time.",
    fit: ["Game UI", "Mobile apps", "Design systems", "Prototypes", "Accessibility audits"],
    formNote: "No mailing lists. Your details are only used to reply to you."
}
